import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeHelperService } from './date-helper.service';

@Pipe({
    name: 'dateformat'
})
export class DateTimeFormatPipe implements PipeTransform {
    constructor(private dateSer: DateTimeHelperService) {}
    transform(value: any, ...args: any[]): any {
        if (value) {
            let fmt = 'yyyy-MM-dd';
            if (args && args.length) {
                fmt = args[0];
            }

            if (fmt === 'timeago') {
                const locale = args[1] || 'zh-CHS';
                return this.dateSer.relativeTime(value, locale);
            }

            return this.dateSer.formatTo(value, fmt);
        }
    }
}